var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient } from '@angular/common/http';
import { Cacheable } from 'ngx-cacheable';
import { Observable } from 'rxjs';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./localization.service";
var LanguageService = /** @class */ (function () {
    function LanguageService(http, baseUrl, localizationService) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.CACHE_KEY = 'Languages';
        this.apiUrl = this.baseUrl + "api/Language";
    }
    LanguageService.prototype.getLanguages = function () {
        return this.http.get("" + this.apiUrl);
    };
    LanguageService.prototype.getKnownLanguages = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getKnownLanguagesCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) { return _this.getKnownLanguagesCall(obs); });
        });
    };
    LanguageService.prototype.getKnownLanguagesCall = function (subscriber) {
        var code = this.localizationService.getLocale();
        if (LanguageService.cache[code]) {
            subscriber.next(LanguageService.cache[code]);
            return;
        }
        this.http.get(this.apiUrl + "/known").subscribe(function (languages) {
            LanguageService.cache[code] = languages;
            subscriber.next(languages);
        }, function (error) { return subscriber.error(error); });
    };
    LanguageService.cache = {};
    LanguageService.ngInjectableDef = i0.defineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.inject(i1.HttpClient), i0.inject("BASE_URL"), i0.inject(i2.LocalizationService)); }, token: LanguageService, providedIn: "root" });
    __decorate([
        Cacheable(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LanguageService.prototype, "getLanguages", null);
    return LanguageService;
}());
export { LanguageService };
